export default __webpack_public_path__ + "static/media/footer-map.86f767ac.png";